import React from "react"
import PageBanner from "../Components/PageBanner";

const Contactp = () => {
    return (
        <div className="pt-20 bg-[#F6F5F1]">
            <PageBanner eyebrow="Get in touch" title="Contact us" />
        </div>
    )
}

export default Contactp;